export class FinbondFileModel {
  fileName: string;
  fileContents: string;
  contentType: string;
}

